import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenManagerService } from '../services/token-manager.service';
import { BehaviorSubject, catchError, filter, switchMap, take, throwError, timeout } from 'rxjs';
import { Router } from '@angular/router';
import { AccountService } from '../services/account.service';

let isRefreshing = false;
let refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenManager: TokenManagerService = inject(TokenManagerService);
  const accountService: AccountService = inject(AccountService);
  const router: Router = inject(Router);

  const currentUrl = window.location.pathname;

  if (req.url.includes('login') || req.url.includes('forgot-password') || req.url.includes('reset-panel-user-password'))
    return next(req);

  if (tokenManager.isLogged() || currentUrl.includes('recuperar-senha') || currentUrl.includes('redefinir-senha')) {
    const token = tokenManager.getToken();

    if (token && req.url.includes('api')) {
      if (tokenManager.isTokenExpired(80) && !req.url.includes('refresh-token')) {
        if (!isRefreshing) {
          isRefreshing = true;
          refreshTokenSubject.next(null);

          return accountService.refreshToken().pipe(
            timeout(10000),
            switchMap((response: any) => {
              isRefreshing = false;
              refreshTokenSubject.next(response.token);
              return next(addTokenHeader(req, response.token));
            }),
            catchError(err => {
              isRefreshing = false;
              refreshTokenSubject.next(null);

              if (err.status === 401 && req.url.includes('refresh-token')) {
                accountService.logout();
                router.navigate(['/account/login']);
              }

              return throwError(() => err);
            })
          );
        } else {
          return refreshTokenSubject.pipe(
            filter(token => token !== null),
            take(1),
            switchMap(token => next(addTokenHeader(req, token!)))
          );
        }
      }

      req = addTokenHeader(req, token);
    }
  } else {
    return router.navigate(['/account/login']) as any;
  }

  return next(req).pipe(
    catchError(err => {
      if (err.status === 401) {
        const route = window.location.pathname;
        const ignoredRoutes = ['recuperar-senha', 'redefinir-senha'];

        if (!ignoredRoutes.some(r => route.includes(r)) && !req.url.includes('refresh-token')) {
          accountService.logout();
          router.navigate(['/account/login']);
        }
      }
      return throwError(() => err);
    })
  );
};

function addTokenHeader(request: HttpRequest<any>, token: string) {
  return request.clone({
    setHeaders: {
      Authorization: 'Bearer ' + token,
    },
  });
}
